import React from 'react'
import { Checkbox, Label } from './component.styles'
import PropTypes from 'prop-types'

export const CustomCheckBox = ({
  checked,
  isDisabled,
  name,
  text,
  onChange,
}) => {
  return (
    <Label>
      <Checkbox
        checked={checked}
        disabled={isDisabled}
        name={name}
        onChange={onChange}
      />
      {text}
    </Label>
  )
}

CustomCheckBox.propTypes = {
  checked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  text: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/CustomCheckBox/component.js